import DataQualityTestCRUDActions from '../actions/DataQualityTestCRUDActions';
import {
  DataQualityTestConfigurationResponse,
  DataQualityTestResult,
} from '../model/DataQualityTestModel';
import { setBusy, setUnBusy, update } from './common/commonReducers';

export type DataQualityTestState = {
  configuration: DataQualityTestConfigurationResponse;
  results: DataQualityTestResult | null;
  busy: boolean;
};

const initialState: DataQualityTestState = {
  configuration: {},
  results: null,
  busy: false,
};

function dataQualityTest(state = initialState, action) {
  switch (action.type) {
    case DataQualityTestCRUDActions.busyAction:
      return setBusy(state);
    case DataQualityTestCRUDActions.unbusyAction:
      return setUnBusy(state);
    case DataQualityTestCRUDActions.retrievedAllAction:
      return {
        ...state,
        configuration: action.entities,
      };
    case DataQualityTestCRUDActions.retrievedResultAction:
      return {
        ...state,
        results: action.results,
      };
    default:
      return state;
  }
}

export default dataQualityTest;
